import React from 'react'
import Modal from 'components/modal'
import Button from 'components/controls/button'

import 'less/edit-sample-size-modal.less'

const EditSampleSizeWarningModal = props => {
  return (
    <Modal
      isOpen={props.isOpen}
      className="edit-sample-size-modal"
      title={props.t('edit.sample.size.title')}
      submitBtnText={props.t('save.and.confirm')}
      onCancel={props.onClose}
      onSubmit={() => props.updateProjectSampleSize({ id: props.projectId, sampleSize: props.sampleSize })}
      isSubmitting={props.isSubmitting}
      showCancelBtn={false}
      additionalButtons={[
        <Button
          className="back"
          onClick={() => props.goBack({ sampleSize: props.sampleSize, id: props.projectId, initialSampleSize: props.sampleSize, initialSampleSizeBeforeWarning: props.initialSampleSize})}
        > {props.t('back')} </Button>
      ]}
    >
      <p>{props.t('edit.sample.size.warning.message')} </p>
    </Modal>
  )
}

export default EditSampleSizeWarningModal
